import {PublicLayout, BasicLayout, ManageRouterLayout} from '@/layout'
import { RouteRecordRaw } from 'vue-router'

// 权限菜单
const roleRoutes:Array<RouteRecordRaw> = [
  {
    path: '/manage',
    name: 'manage',
    redirect: '/manage/dashboard',
    component: BasicLayout,
    children: [
      // 数据
      {
        path: '/manage/dashboard',
        name: 'manage-dashboard',
        redirect: '/manage/dashboard/index',
        component: ManageRouterLayout,
        meta: {
          title: '数据',
          keepAlive: true,
          icon: 'icon-data'
        },
        children: [
          {
            path: '/manage/dashboard/index',
            name: 'manage-dashboard-index',
            component: () => import('@/views/manage/dashboard/DashboardIndex.vue'),
            meta: { title: '数据展示', keepAlive: true, permission: ['manage-dashboard-index'] }
          }
        ]
      },
      // 活动
      {
        path: '/manage/activity',
        name: 'manage-activity',
        redirect: '/manage/activity/list',
        component: ManageRouterLayout,
        meta: {
          title: '活动',
          keepAlive: true,
          icon: 'icon-16'
        },
        children: [
          {
            path: '/manage/activity/list',
            name: 'manage-activity-list',
            component: () => import('@/views/manage/activity/ActivityList.vue'),
            meta: { title: '活动管理', keepAlive: true, permission: ['manage-activity-list'] }
          },
          {
            path: '/manage/store-activity/list',
            name: 'manage-store-activity-list',
            component: () => import('@/views/manage/activity/StoreActivityList.vue'),
            meta: { title: '活动管理', keepAlive: true, permission: ['manage-store-activity-list'] }
          },
          {
            path: '/manage/activity/form',
            name: 'manage-activity-form',
            component: () => import('@/views/manage/activity/ActivityForm.vue'),
            meta: { title: '添加活动', isHidden: true, parent: 'manage-activity-list', permission: ['manage-activity-form'] }
          },
          {
            path: '/manage/activity/edit/:id',
            name: 'manage-activity-edit',
            component: () => import('@/views/manage/activity/ActivityFormEdit.vue'),
            meta: { title: '编辑活动', isHidden: true, parent: 'manage-activity-list', permission: ['manage-activity-edit'] }
          },
          {
            path: '/manage/activity/type',
            name: 'manage-activity-type',
            component: () => import('@/views/manage/activity-type/TypeList.vue'),
            meta: { title: '活动分类', keepAlive: true, permission: ['manage-activity-type'] }
          },
          {
            path: '/manage/activity/sign',
            name: 'manage-activity-sign',
            component: () => import('@/views/manage/activity-in/DataList.vue'),
            meta: { title: '活动打卡记录', keepAlive: true, permission: ['manage-activity-sign'] }
          },
          {
            path: '/manage/store-activity/sign',
            name: 'manage-store-activity-sign',
            component: () => import('@/views/manage/activity-in/StoreDataList.vue'),
            meta: { title: '活动打卡记录', keepAlive: true, permission: ['manage-store-activity-sign'] }
          },
          {
            path: '/manage/activity/apply',
            name: 'manage-activity-apply',
            component: () => import('@/views/manage/apply/ApplyList.vue'),
            meta: { title: '商家入驻', keepAlive: true, permission: ['manage-activity-apply'] }
          },
          {
            path: '/manage/activity/message',
            name: 'manage-activity-message',
            component: () => import('@/views/manage/message/MessageList.vue'),
            meta: { title: '留言管理', keepAlive: true, permission: ['manage-activity-message'] }
          },
          {
            path: '/manage/store-activity/message',
            name: 'manage-store-activity-message',
            component: () => import('@/views/manage/message/StoreMessageList.vue'),
            meta: { title: '留言管理', keepAlive: true, permission: ['manage-store-activity-message'] }
          },
          {
            path: '/manage/activity/insurance',
            name: 'manage-activity-insurance',
            component: () => import('@/views/manage/insurance/InsuranceList.vue'),
            meta: { title: '保险广告', keepAlive: true, permission: ['manage-activity-insurance'] }
          }
        ]
      },
      // 文章
      {
        path: '/manage/article',
        name: 'manage-article',
        redirect: '/manage/article/list',
        component: ManageRouterLayout,
        meta: {
          title: '文章',
          keepAlive: true,
          icon: 'icon-16'
        },
        children: [
          {
            path: '/manage/article/list',
            name: 'manage-article-list',
            component: () => import('@/views/manage/artiles/ArtileList.vue'),
            meta: { title: '文章管理', keepAlive: true, permission: ['manage-article-list'] }
          },
          {
            path: '/manage/article/type',
            name: 'manage-article-type',
            component: () => import('@/views/manage/artiles/ArticleType.vue'),
            meta: { title: '文章类型', keepAlive: true, permission: ['manage-article-type'] }
          }
        ]
      },
      // 广告
      {
        path: '/manage/ad',
        name: 'manage-ad',
        redirect: '/manage/ad/list',
        component: ManageRouterLayout,
        meta: {
          title: '广告',
          keepAlive: true,
          icon: 'icon-zhongdianguanggaowei'
        },
        children: [
          {
            path: '/manage/ad/list',
            name: 'manage-ad-list',
            component: () => import('@/views/manage/ad/AdList.vue'),
            meta: { title: '广告管理', keepAlive: true, permission: ['manage-ad-list'] }
          }
        ]
      },
      // 用户
      {
        path: '/manage/user',
        name: 'manage-user',
        redirect: '/manage/admin/list',
        component: ManageRouterLayout,
        meta: {
          title: '用户',
          keepAlive: true,
          icon: 'icon-user'
        },
        children: [
          {
            path: '/manage/sadmin/list',
            name: 'manage-sadmin-list',
            component: () => import('@/views/manage/user/SAdminList.vue'),
            meta: { title: '超级管理员', keepAlive: true, permission: ['manage-sadmin-list'] }
          },
          {
            path: '/manage/admin/list',
            name: 'manage-admin-list',
            component: () => import('@/views/manage/user/AdminList.vue'),
            meta: { title: '管理员', keepAlive: true, permission: ['manage-admin-list'] }
          },
          {
            path: '/manage/user/store',
            name: 'manage-user-store',
            component: () => import('@/views/manage/user/StoreList.vue'),
            meta: { title: '商家会员', keepAlive: true, permission: ['manage-user-store'] }
          },
          {
            path: '/manage/user/list',
            name: 'manage-user-list',
            component: () => import('@/views/manage/user/UserList.vue'),
            meta: { title: '普通会员', keepAlive: true, permission: ['manage-user-list'] }
          }
        ]
      },
      // 权限
      {
        path: '/manage/role',
        name: 'manage-role',
        redirect: '/manage/role/list',
        component: ManageRouterLayout,
        meta: {
          title: '权限',
          keepAlive: true,
          icon: 'icon-quanxian'
        },
        children: [
          {
            path: '/manage/role/list',
            name: 'manage-role-list',
            component: () => import('@/views/manage/roles/RoleList.vue'),
            meta: { title: '角色管理', keepAlive: true, permission: ['manage-role-list'] }
          },
          {
            path: '/manage/rule/list',
            name: 'manage-rule-list',
            component: () => import('@/views/manage/roles/PermissionList.vue'),
            meta: { title: '权限管理', keepAlive: true, permission: ['manage-rule-list'] }
          }
        ]
      },
      // 系统
      {
        path: '/manage/system',
        name: 'manage-system',
        redirect: '/manage/system/config',
        component: ManageRouterLayout,
        meta: {
          title: '系统',
          keepAlive: true,
          icon: 'icon-xitong'
        },
        children: [
          {
            path: '/manage/system/config',
            name: 'manage-system-config',
            component: () => import('@/views/manage/system/SysConfig.vue'),
            meta: { title: '系统配置', keepAlive: true, permission: ['manage-system-config'] }
          },
          {
            path: '/manage/log/list',
            name: 'manage-log-list',
            component: () => import('@/views/manage/system/LogList.vue'),
            meta: { title: '操作日志', keepAlive: true, permission: ['manage-log-list'] }
          }
        ]
      }
    ]
  }
]

// 通用菜单
const normalRoutes:Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    redirect: '/manage',
    children: []
  },
  {
    path: '/manage',
    name: 'manage',
    component: BasicLayout,
    children: []
  },
  {
    path: '/manage',
    component: PublicLayout,
    redirect: '/manage/login',
    children: [
      {
        path: '/manage/login',
        name: 'manage-login',
        component: () => import('@/views/public/UserLogin.vue'),
        meta: { title: '登录' }
      },
      {
        path: '/manage/store-login',
        name: 'manage-store-login',
        component: () => import('@/views/public/StoreLogin.vue'),
        meta: { title: '商户登录' }
      },
      {
        path: '/manage/forget',
        name: 'manage-forget',
        component: () => import('@/views/public/UserForget.vue'),
        meta: { title: '忘记账号' }
      },
      {
        path: '/manage/forgetpsw',
        name: 'manage-forgetpsw',
        component: () => import('@/views/public/UserForgetPsw.vue'),
        meta: { title: '忘记密码' }
      }
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: BasicLayout,
    redirect: '/account/index',
    children: [
      {
        path: '/account/index',
        name: 'account-index',
        redirect: '/account/info',
        component: () => import('@/views/manage/account/AccountIndex.vue'),
        meta: { title: '账号管理', keepAlive: true },
        children: [
          {
            path: '/account/info',
            name: 'account-info',
            component: () => import('@/views/manage/account/UserInfo.vue'),
            meta: { title: '我的信息', keepAlive: true }
          },
          {
            path: '/account/safe',
            name: 'account-safe',
            component: () => import('@/views/manage/account/SafeInfo.vue'),
            meta: { title: '安全设置', keepAlive: true }
          }
        ]
      }
    ]
  },
  {
    path: '/three',
    name: 'three',
    component: () => import('@/views/public/ThreeJs.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/public/exception/NotFound.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/public/exception/NotFound.vue')
  }
]

const hasHiddenChildren = []
export {roleRoutes, normalRoutes,hasHiddenChildren}